import React from "react";
import { BiHeadphone, BiLock, BiPhone } from "react-icons/bi";
import { CiDeliveryTruck, CiMail } from "react-icons/ci";
import { FaFacebookSquare, FaInstagramSquare } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { LuLogOut } from "react-icons/lu";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";

const Footer = () => {
  const highlights = [
    {
      icon: <CiDeliveryTruck />,
      title: "Free Shipping",
      subTitle: "On all orders over ₹500",
    },
    {
      icon: <BiHeadphone />,
      title: "24/7 Support",
      subTitle: "We're here to help anytime",
    },
    {
      icon: <LuLogOut />,
      title: "30 Days Return",
      subTitle: "Easy and hassle-free",
    },
    {
      icon: <BiLock />,
      title: "Secure Payment",
      subTitle: "100% secure transactions",
    },
  ];

  return (
    <footer className="bg-black text-white text-sm">
      <div className="px-5 md:px-20 py-10 space-y-10">
        {/* Highlights Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="flex items-center border border-gray-600 px-4 py-3 rounded-md hover:border-white transition"
            >
              <div className="text-3xl mr-4 text-primary">{item.icon}</div>
              <div>
                <h5 className="font-bold">{item.title}</h5>
                <p className="text-gray-400 text-xs">{item.subTitle}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation & Newsletter */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* About */}
          <div>
            <h3 className="uppercase mb-4 font-semibold text-gray-200">About Fivea</h3>
            <ul className="space-y-2">
              {["About Us", "Our Showrooms"].map((text, i) => (
                <li key={i} className="text-gray-400 hover:text-white cursor-pointer">
                  <Link to='/about us'>{text}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="uppercase mb-4 font-semibold text-gray-200">Support</h3>
            <ul className="space-y-2">
              {["Contact Us", "Return Policy", "Privacy Policy"].map((text, i) => (
                <li key={i} className="text-gray-400 hover:text-white cursor-pointer">
                  <Link to='/about us'>{text}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* My Account */}
          <div>
            <h3 className="uppercase mb-4 font-semibold text-gray-200">My Account</h3>
            <ul className="space-y-2">
              {["Shopping Bag", "Wishlist", "Order History", "Payment"].map((text, i) => (
                <li key={i} className="text-gray-400 hover:text-white cursor-pointer">
                  <Link to={text==="Shopping Bag"?"/cart":"/account"}>{text}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="uppercase mb-4 font-semibold text-gray-200">Stay Updated</h3>
            <p className="text-gray-400 mb-4">
              Subscribe to receive special offers, giveaways, and once-in-a-lifetime deals.
            </p>
            <div className="flex items-center overflow-hidden bg-white">
              <input
                type="email"
                className="text-black w-full px-4 py-2 outline-none"
                placeholder="Enter your email"
                aria-label="Email address"
              />
              <button className="bg-primary text-white px-4 py-2 hover:bg-opacity-80 transition">
                <MdEmail size={20} />
              </button>
            </div>
          </div>
        </div>

        {/* Contact and Location Info */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Support Contact */}
          <div className="space-y-2">
            <h3 className="uppercase font-semibold text-gray-200">For Support</h3>
            <div className="flex items-center gap-2 text-gray-400">
              <BiPhone />
              <a href="tel:+919042014963" className="hover:text-white">
                +91 90420 14963
              </a>
            </div>
            <div className="flex items-center gap-2 text-gray-400">
              <BiPhone />
              <a href="tel:+919344420998" className="hover:text-white">
                +91 93444 20998
              </a>
            </div>
            <div className="flex items-center gap-2 text-gray-400">
              <BiPhone />
              <a href="tel:+918248843915" className="hover:text-white">
                +91 82488 43915
              </a>
            </div>
            <div className="flex items-center gap-2 text-gray-400">
              <CiMail />
              <a href="mailto:admin@fivea.in" className="hover:text-white">
                admin@fivea.in
              </a>
            </div>
            <div className=" flex gap-4 pt-10">
              <a href="https://www.facebook.com/ComfortByFivea" target="_blank" className=" hover:text-blue-600"><FaFacebookSquare size={25}/></a>
              {/* <a href="" className=" hover:bg-white hover:text-black rounded-md"><FaXTwitter size={25}/></a> */}
              <a href="https://www.instagram.com/comfortbyfivea" target="_blank" className=" hover:text-primary"><FaInstagramSquare size={25}/></a>
            </div>
          </div>

          {/* Store Address */}
          <div>
            <h3 className="uppercase font-semibold text-gray-200 mb-2">Our Store</h3>
            <p className="text-gray-400">
              S F No. 47/2, D No.15, Palar Salai, near OLA Bike Showroom, Virthampet,
              Katpadi, Vellore, Tamil Nadu 632006
            </p>
          </div>

          {/* Google Map */}
          <div className=" md:col-span-2">
            <iframe
              title="Fivea Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31107.698002844278!2d79.11523699106579!3d12.942246092088633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad396269e678fd%3A0xf49d15ba35cffb28!2zRml2ZWEgLSBGdXJuaXR1cmUgU2hvd3Jvb20gaW4gVmVsbG9yZSDgroPgrqrgrr_grrXgr43grq_grr4!5e0!3m2!1sen!2sin!4v1752826444891!5m2!1sen!2sin"
              width="100%"
              height="250"
              loading="lazy"
              className=" border-none"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      <hr className="border-gray-700" />

      {/* Bottom Footer */}
      <div className="py-5 mb-14 md:mb-0 px-5 md:px-20 flex flex-col md:flex-row justify-between items-center text-gray-500 text-xs gap-2">
        <span>© {new Date().getFullYear()} Fivea Ventures Private Limited. All rights reserved.</span>
        <div className="flex gap-4">
          <Link to="/about us" className="hover:text-white">Terms</Link>
          <Link to="/about us" className="hover:text-white">Privacy</Link>
          <Link to="/about us" className="hover:text-white">Cookies</Link>
        </div>
        <span>Developed by <a href="https://azerotech.com/" target="_blank" className=" hover:text-white">azero tech</a></span>
      </div>
    </footer>
  );
};

export default Footer;
